import {lazy} from "react";
import {authRoles} from "app/auth/authRoles";

const DocumentWorkspace = lazy(() => import("./DocumentWorkspace"));

const documentWorkspaceRoutes = [
    {
        path: "/document-workspace",
        element: <DocumentWorkspace/>,
        auth: authRoles.admin,
    },
];

export default documentWorkspaceRoutes;